import { render, staticRenderFns } from "./TransactionPerson.vue?vue&type=template&id=5227d138&scoped=true&"
import script from "./TransactionPerson.vue?vue&type=script&lang=js&"
export * from "./TransactionPerson.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPerson.vue?vue&type=style&index=0&id=5227d138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227d138",
  null
  
)

export default component.exports